<nz-table
  #sortTable
  #rowSelectionTable
  [nzData]="(organizationUsers$ | async)?.result?.items ?? []"
  [nzFrontPagination]="false"
  [nzLoading]="loading"
  [nzTotal]="(organizationUsers$ | async)?.result?.totalRows || 0"
  [(nzPageIndex)]="pageIndex"
  [nzPageSize]="pageSize"
  (nzQueryParams)="onQueryParamsChange($event)"
  [nzScroll]="{ x: '1200px', y: 'calc(100vh - 290px)' }">
  <thead>
    <tr>
      <!-- <th
        nzWidth="50px"
        [nzSelections]="listOfSelection"
        [(nzChecked)]="checked"
        [nzIndeterminate]="indeterminate"
        (nzCheckedChange)="onAllChecked($event)"></th> -->
      <th [nzSortFn]="true" nzColumnKey="enrollId">Student Id</th>
      <th [nzSortFn]="true" nzColumnKey="firstName">Student Name</th>
      <th [nzSortFn]="true" nzColumnKey="race">Race</th>
      <th [nzSortFn]="true" nzWidth="80px" nzColumnKey="gender">Gender</th>
      <th [nzSortFn]="true" nzColumnKey="dateOfBirth">Date of Birth</th>
      <th [nzSortFn]="true" nzWidth="100px" nzColumnKey="isSpecialEd">
        Special Ed
      </th>
      <th [nzSortFn]="true" nzWidth="110px" nzColumnKey="isSuspended">
        Suspended
      </th>
      <th [nzSortFn]="true" nzWidth="100px" nzColumnKey="isExpelled">
        Expelled
      </th>
      <th nzRight nzWidth="50px"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of rowSelectionTable.data; let i = index">
      <!-- <td
        [nzChecked]="setOfCheckedId.has(data.id)"
        (nzCheckedChange)="onItemChecked(data.id, $event)"></td> -->
      <td>{{ data.enrollId }}</td>
      <td>{{ data.firstName }} {{ data.lastName }}</td>
      <td [title]="data.race">{{ data.race }}</td>
      <td [title]="data.race">{{ data.gender }}</td>
      <td>
        {{ data.dateOfBirth ? (data.dateOfBirth | date: 'MM/dd/yyyy') : '-' }}
      </td>
      <td>{{ data.isSpecialEd === true ? 'Yes' : 'No' }}</td>
      <td>{{ data.isSuspended === true ? 'Yes' : 'No' }}</td>
      <td>{{ data.isExpelled === true ? 'Yes' : 'No' }}</td>
      <td nzRight>
        <div class="action-btn-wrapper">
          <button
            nz-button
            nzType="default"
            class="action-btn"
            (click)="showDeleteModal(data)">
            <svg-icon
              [title]="'Delete Student'"
              src="/assets/icon/icon-trash.svg"
              class="icon s-20"></svg-icon>
          </button>
        </div>
      </td>
    </tr>
  </tbody>
</nz-table>
<app-confirm-dialog
  [isVisible]="isVisible"
  [title]="'Delete Student'"
  [message]="
    'Are you sure you want to delete student ' +
    selectedRow?.firstName +
    ' ' +
    selectedRow?.lastName +
    '? This action cannot be undone.'
  "
  [iconSrc]="'/assets/icon/icon-trash-red.svg'"
  [iconColor]="'red'"
  [cancelText]="'Cancel'"
  [loading]="isDeleting"
  [confirmText]="'Delete'"
  (confirmed)="handleOkMiddle()"
  (cancelled)="handleCancelMiddle()"
  (closed)="handleCancelMiddle()">
</app-confirm-dialog>
